import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {MedicalRecordVisitReasonModel} from '../model/medicalRecordVisitReason.model';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {MedicalRecordPainConverter} from '../../../pain/api/converter/medicalRecordPain.converter';
import {Injectable} from '@angular/core';
import {MedicalRecordVisitReasonLabelConverter} from './medicalRecordVisitReasonLabel.converter';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';

@Injectable({providedIn: 'root'})
export class MedicalRecordVisitReasonConverter extends HttpModelConverter<MedicalRecordVisitReasonModel> {

    constructor(private dateConverter: DateConverter,
                private medicalRecordVisitReasonLabelConverter: MedicalRecordVisitReasonLabelConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter,
                private medicalRecordPainConverter: MedicalRecordPainConverter) {
        super();
    }

    protected createInstance(): MedicalRecordVisitReasonModel {
        return new MedicalRecordVisitReasonModel();
    }

    protected enrichObject(result: MedicalRecordVisitReasonModel, src: MedicalRecordVisitReasonModel) {
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.date = this.dateConverter.convert(src.date);
        result.pains = this.medicalRecordPainConverter.convertFromArray(src.pains);
        result.labels = this.medicalRecordVisitReasonLabelConverter.convertFromArray(src.labels);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
    }
}
